import {
  CANVA_PROVIDER,
  CANVA_SCOPE,
} from 'src/app/template-editor/template-components/services/canva.service';

export interface UserProviderMeta {
  name: string;
  logo: string;
  hideUsername?: boolean;
  groupId?: string;
}

export const FACEBOOK_PAGES_PROVIDER = 'facebook-business';
export const INSTAGRAM_PROVIDER = 'instagram-business';

export const USER_PROVIDER_META: Record<string, UserProviderMeta> = {
  canva: {
    name: 'Canva',
    logo: 'component-canva',
    hideUsername: true,
  },
  'facebook-consumer': {
    name: 'Facebook',
    logo: 'integration-facebook',
  },
  'facebook-business': {
    name: 'Facebook Pages',
    logo: 'integration-facebook',
  },
  'instagram-business': {
    name: 'Instagram',
    logo: 'integration-instagram',
  },
  google: {
    name: 'Google',
    logo: 'integration-google',
  },
  'ms-graph': {
    name: 'Microsoft',
    logo: 'integration-microsoft',
    groupId: 'microsoft',
  },
  'ms-pbi': {
    name: 'Microsoft',
    logo: 'integration-microsoft',
    groupId: 'microsoft',
  },
};

export const RECONNECT_SCOPES: Record<string, string> = {
  google: [
    'https://www.googleapis.com/auth/calendar.readonly',
    'https://www.googleapis.com/auth/drive.file',
    'https://www.googleapis.com/auth/spreadsheets.readonly',
  ].join(' '),
  'ms-graph': [
    'Calendars.Read',
    'Calendars.Read.Shared',
    'Files.Read.All',
    'Sites.Read.All',
    'User.Read',
  ].join(' '),
  'ms-pbi': [
    'https://analysis.windows.net/powerbi/api/Workspace.Read.All',
    'https://analysis.windows.net/powerbi/api/Report.Read.All',
    'https://analysis.windows.net/powerbi/api/Dashboard.Read.All',
  ].join(' '),
  [CANVA_PROVIDER]: CANVA_SCOPE,
  'facebook-consumer': 'user_posts',
  'facebook-business':
    'pages_show_list,pages_read_engagement,pages_read_user_content,business_management',
  'instagram-business': 'instagram_business_basic',
};
